import { Button } from '@mm/components';
import { SubscriptionModel } from '@mm/state/model/SubscriptionModel';
import { isNumber } from 'lodash';
import React from 'react';
import { PrimaryToolTip } from '../../../../../../../common/components/PrimaryToolTip/PrimaryToolTip';
import './SeatsArea.pcss';

type Props = {
  changeSeats: () => void;
  subscription: SubscriptionModel;
};

export const SeatsArea = ({ changeSeats, subscription }: Props) => {
  const userSeatsDowngrade = subscription?.addOnDowngrades?.userSeatsDowngrade;
  const showPopup = isNumber(userSeatsDowngrade);
  const disabled =
    !!subscription?.expiresAt && subscription?.state !== 'active';
  const userSeatsInPlan = subscription?.userSeatsUsed;

  if (!subscription.userSeats) {
    return <></>;
  }

  return (
    <div className="seats-area_container">
      <PrimaryToolTip
        useHover={true}
        toolTipDisabled={disabled || !showPopup}
        withoutLine
        align="end"
        title={disabled ? 'Subscription Canceled' : 'Seats Downgraded'}
        classNameTitle="active-plan-details__tooltip-title"
        anchorElement={
          <Button
            css={{ container: 'seats-area__button' }}
            color="transparent"
            onClick={changeSeats}
            disabled={disabled || showPopup}
          >
            Manage seats
          </Button>
        }
      >
        {' '}
        {disabled
          ? 'Canceled plans can&lsquo;t change seats number'
          : `Lowered since next billing cycle to
        ${(userSeatsDowngrade || 0) + userSeatsInPlan} 
        ${userSeatsDowngrade === 1 ? 'seat' : 'seats'}`}
      </PrimaryToolTip>
    </div>
  );
};
